toastr = require('../../../../../ngapp/external-scripts/toastr/toastr')

FlashService = ->
  toastr.options =
    closeButton: true
    positionClass: "toast-top-full-width"
    showDuration: "300"
    hideDuration: "1000"
    timeOut: "5000"
    extendedTimeOut: "1000"
    preventDuplicates: true #preventDuplicate does not work now

  error: (text, options) ->
    #For special purpose -> show long message
    toastr.error(text) unless options
    toastr.error(text , '', options) if options

  success: (text) ->
    toastr.success(text)

  warning: (text, options) ->
    toastr.warning(text) unless options
    toastr.warning(text , '', options) if options

module.exports = FlashService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/flash/flash-service.coffee